import {AbstractControl} from "@angular/forms";
import {getStrByteLength, isArrayLike, isInteger, isNumber, isRegexp, isString} from "./ccl-util";

/**
 * éªè¯ä¸ä¸ª ngModel æ¯å¦æ»¡è¶³ rule è§å
 * @param rule è§å
 * @param ngModel
 */
export function _cclValidate(rule: any, ngModel: AbstractControl): { key, msg } {
    // æåºrequiredï¼ä½¿å¾å¦æærequiredæ ¡éªæ¶ï¼å®æ»æ¯ç¬¬ä¸ä¸ªè§¦åç
    rule = rule || {};

    rule = Object.assign({}, _CclValidateRuleGroup[rule.ruleGroup] || {}, rule);

    let rules = sortRequired(Object.keys(rule));

    for (let i = 0; i < rules.length; i++) {
        const key = rules[i];
        const ruleValue = rule[key];
        if (_ValidateFns[key]) {
            const msg = _ValidateFns[key](ruleValue, ngModel.value);
            if (msg) {
                return {key, msg};
            }
        }
    }

    return null;
}

/**
 * åå»ºä¸ä¸ªå¯ä¾FormBuilderä½¿ç¨çæ ¡éªå¨
 * @param rule
 * @example
 *   this.fb.group({
 *       userName : [ '' , cclValidateFn( { required:true , minLength:5 , maxLength:15 } ) ],
 *       address : [ '' , cclValidateFn( { required:true , ruleGroup:'address' } ) ]
 *   })
 */
export function cclValidateFn(rule: any) {
    return (ngModel) => _cclValidate(rule, ngModel);
}

/**
 * æ·»å ä¸ä¸ªéªè¯å¨
 * @param name  éªè¯å¨åç§°
 * @param fn  éªè¯å½æ°
 */
export function addCclValidate(name: string, fn: (valid, value) => void | string) {
    _ValidateFns[name] = fn;
}

/**
 * æ·»å æ­£åéªè¯ï¼è¾å¥åå®¹å¿é¡»æ»¡è¶³æ­£å
 * @param name
 * @param reg
 * @param msg
 */
export function addCclRegValidate(name: string, reg: RegExp, msg?: string) {
    if (name && isRegexp(reg)) {
        _ValidateFns[name] = function (validate, value) {
            if (validate && !reg.test(value)) {
                return msg || `åå®¹ä¸ç¬¦åæ­£å:\`${reg.toString()}\``;
            }
        }
    }
}

/**
 * æ·»å æ­£åéªè¯ï¼è¾å¥åå®¹ä¸è½åå«æ­£åéå¶é¡¹(ååæ­£åéªè¯)
 * @param name
 * @param reg
 * @param msg
 */
export function addCclNoRegValidate(name: string, reg: RegExp, msg?: string) {
    if (name && isRegexp(reg)) {
        _ValidateFns[name] = function (validate, value) {
            if (validate && reg.test(value)) {
                return msg || `åå®¹ä¸è½åå«æ­£å:\`${reg.toString()}\``;
            }
        }
    }
}

/**
 * æ·»å ä¸ç»éªè¯è§å
 * @param ruleGroupName ç»ååç§°
 * @param ruleGroup éªè¯è§å
 */
export function addCclValidateRuleGroup(ruleGroupName, ruleGroup) {
    _CclValidateRuleGroup[ruleGroupName] = ruleGroup;
}

export const _CclValidateRuleGroup = {};

export const _ValidateFns = {
    // éå¶æ°å­æå¤§å¼
    max: function (max, value) {
        if (!isNumber(max) || value == null) {
            return;
        }
        value = +value;
        if (isFinite(max) && isFinite(value) && value > max) {
            return `ä¸è½å¤§äº ${max}`;
        }
    },

    // éå¶æ°å­æå°å¼
    min: function (min, value) {
        if (!isNumber(min) || value == null) {
            return;
        }
        value = +value;
        if (isFinite(min) && isFinite(value) && value < min) {
            return `ä¸è½å°äº ${min}`;
        }
    },

    // æ ¡éªæå¤§é¿åº¦(string , ArrayLike)
    maxLength: function (maxLength: number, value: any[]) {
        if (!isNumber(maxLength) || maxLength <= 0 || !isArrayLike(value) || !value.length) {
            return;
        }
        maxLength = Math.abs(maxLength);
        if (isInteger(maxLength) && maxLength && value.length > maxLength) {
            if (isString(value)) {
                return `æå¤§é¿åº¦ä¸º ${maxLength}`;
            } else {
                return `æå¤æ¯æ ${maxLength} é¡¹`;
            }
        }
    },

    // æ ¡éªæå°é¿åº¦(string , ArrayLike)
    minLength: function (minLength: number, value: any[]) {
        if (!isNumber(minLength) || minLength <= 0 || !isArrayLike(value) || !value.length) {
            return;
        }
        minLength = Math.abs(minLength);
        if (isInteger(minLength) && minLength && value.length < minLength) {
            if (isString(value)) {
                return `æå°é¿åº¦ä¸º ${minLength}`;
            } else {
                return `è³å°éè¦ ${minLength} é¡¹`;
            }
        }
    },

    // æå¤§å­èé¿åº¦(ä¸ä¸ªæ±å­ = 2å­ç¬¦)
    maxByteLength: function (maxByteLength, value: string) {
        value = value || '';
        if (!isNumber(maxByteLength) || maxByteLength <= 0 || !isString(value) || !value.length) {
            return;
        }
        maxByteLength = Math.abs(maxByteLength);
        if (isInteger(maxByteLength) && maxByteLength) {
            const byteLen = getStrByteLength(value);
            if (byteLen > maxByteLength) {
                return `ä¸è½è¶è¿ ${maxByteLength} ä¸ªå­ç¬¦(1æ±å­=2å­ç¬¦)ï¼å·²è¾å¥ ${byteLen} ä¸ªå­ç¬¦`;
            }
        }
    },

    // æå°å­èé¿åº¦(ä¸ä¸ªæ±å­ = 2å­ç¬¦)
    minByteLength: function (minByteLength, value: string) {
        value = value || '';
        if (!isNumber(minByteLength) || minByteLength <= 0 || !isString(value) || !value.length) {
            return;
        }
        minByteLength = Math.abs(minByteLength);
        if (isInteger(minByteLength) && minByteLength) {
            const byteLen = getStrByteLength(value);
            if (byteLen < minByteLength) {
                return `ä¸è½å°äº ${minByteLength} ä¸ªå­ç¬¦(1æ±å­=2å­ç¬¦)ï¼å·²è¾å¥ ${byteLen} ä¸ªå­ç¬¦`;
            }
        }
    },

    // å¿å¡«æ ¡éªï¼è¥ä¸ºæ°å­ï¼åè®¸ä¸º0
    required: function (required, value) {
        if (required &&
            (
                value === null || value === undefined || value === '' ||
                Number.isNaN(value) || (isArrayLike(value) && value.length === 0)
            )
        ) {
            return 'è¯¥é¡¹ä¸è½ä¸ºç©º';
        }
    }
};

function sortRequired(arr: string[]) {
    const KEY = 'required';
    const IDX = arr.indexOf(KEY);
    if (IDX > -1) {
        arr.splice(IDX, 1);
        arr.unshift(KEY);
    }

    return arr;
}
